import React, { useState, useEffect } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { reportService } from "../../../Services/report.service";
import { activeCurrencyByDate } from "../../../Helpers/CurrencyConverter";

const UsersList = (props) => {
  const { t: translator } = useTranslation();
  const [data, setData] = useState();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    reportService
      .invoicesConclusionUsers({
        guid: props.guid,
        pageIndex: 0,
        pageSize: 0,
      })
      .then((res) => {
        setData(res.data.data);
        setIsLoading(false);
      })
      .catch((err) => {
        console.error(err.response);
      });
  }, []);

  function currencyFormatter(cell) {
    return new Intl.NumberFormat("hr", {
      style: "currency",
      currency: activeCurrencyByDate(props.date),
    }).format(Number(cell));
  }

  const columns = [
    {
      dataField: "userPrintName",
      text: translator("Report-View-TableHeader-Operator"),
      footer: "Total",
    },
    {
      dataField: "amount",
      text: translator("Report-View-TableHeader-PayValue"),
      formatter: currencyFormatter,
      headerStyle: () => {
        return { width: "150px", textAlign: "right" };
      },
      style: () => {
        return { width: "150px", textAlign: "right" };
      },
      footer: (columnData) =>
        new Intl.NumberFormat("hr", {
          style: "currency",
          currency: activeCurrencyByDate(props.date),
        }).format(
          Number(
            columnData.reduce((acc, item) => Number(acc) + Number(item), 0)
          )
        ),
      footerAlign: (column, colIndex) => "right",
    },
  ];

  return (
    <div className="p-2">
      <div className="container-fluid p-0">
        <div className="card-body pl-0 mb-4 col-lg-8">
          {!isLoading && (
            <BootstrapTable
              keyField="invoiceGuid"
              data={data}
              loading
              ignoreSinglePage
              columns={columns}
              classes={"table-sm"}
              rowClasses="boostrap-table-row"
              noDataIndication={translator("No-Data")}
              pagination={
                data.length > 10
                  ? paginationFactory({
                      hideSizePerPage: true,
                      totalSize: data.length,
                      sizePerPage: 10,
                    })
                  : null
              }
              footerClasses={"footer-background"}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default UsersList;
